/**
 * Utilitários para formatação de datas sem dependências externas
 * Criado para evitar conflitos com bibliotecas de data
 */

/**
 * Formata uma data para o formato brasileiro (dd/mm/yyyy)
 * @param dateString - String da data ou objeto Date
 * @returns Data formatada em dd/mm/yyyy ou string vazia se inválida
 */
export const formatDateToBR = (dateString: string | Date | null): string => {
    if (!dateString) return '';

    try {
        const date = new Date(dateString);

        // Verificar se a data é válida
        if (isNaN(date.getTime())) return '';

        // Formatar manualmente para evitar conflitos
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    } catch (error) {
        return '';
    }
};

/**
 * Formata uma data para o formato ISO (yyyy-mm-dd)
 * @param date - Objeto Date ou null
 * @returns Data formatada em yyyy-mm-dd ou null se inválida
 */
export const formatDateToISO = (date: Date | null): string | null => {
    if (!date) return null;

    try {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    } catch (error) {
        return null;
    }
};

/**
 * Formata uma data para exibição com hora (dd/mm/yyyy HH:mm)
 * @param dateString - String da data ou objeto Date
 * @returns Data formatada com hora ou string vazia se inválida
 */
export const formatDateTimeToDisplay = (dateString: string | Date | null): string => {
    if (!dateString) return '';

    try {
        const date = new Date(dateString);

        // Verificar se a data é válida
        if (isNaN(date.getTime())) return '';

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch (error) {
        return '';
    }
}; 